import { Box, Stack, useTheme } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import PageLayout from '../common/PageLayout';
import LogoutPromptDialog from './dialogs/LogoutPromptDialog';
import LanguageSettings from './sections/LanguageSettings';
import ProfileSection from './sections/ProfileSection';

const SettingsPage = () => {
    const theme = useTheme();
    const { currentUser, currentCtUser, logout } = useAuth();
    const navigate = useNavigate();
    const [showLogoutPrompt, setShowLogoutPrompt] = useState(false);

    const handleLogoutAndVerify = async () => {
        setShowLogoutPrompt(false);
        await logout();
        navigate('/login');
    };

    return (
        <>
            <PageLayout>
                <Box
                    sx={{
                        maxWidth: '1200px',
                        mx: 'auto',
                        pt: 2,
                        px: { xs: 2, sm: 3, md: 4 },
                    }}
                >
                    <Stack spacing={4}>
                        {/* Profile & Account Section */}
                        <ProfileSection
                            supportId={currentUser?.ctUserId?.toString() || ''}
                            currentCtUser={currentCtUser}
                        />

                        {/* Language Settings - Development Only */}
                        { import.meta.env.MODE === 'development' && (
                            <LanguageSettings />
                        )}
                    </Stack>
                </Box>
            </PageLayout>

        <LogoutPromptDialog
            open={showLogoutPrompt}
            onClose={() => setShowLogoutPrompt(false)}
            onConfirm={handleLogoutAndVerify}
        />
    </>
    );
};

export default SettingsPage;
